"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = exports.createAll = void 0;
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
const types_js_1 = require("./types.js");
const measures_js_1 = require("./measures/measures.js");
const filters_js_1 = require("./filters/filters.js");
const index_js_1 = require("./dimensions/index.js");
const attributes_js_1 = require("./attributes.js");
const translatable_error_js_1 = require("../translation/translatable-error.js");
/**
 * Generate an array of dimension model instances out of the given JSON array
 *
 * @param items - a JSON array  to create an elements from
 * @returns a dimensional model instances
 * @internal
 */
function createAll(items) {
    return items.map((e) => create(e));
}
exports.createAll = createAll;
/**
 * Generate a dimension model instance out of the given JSON object
 *
 * @param item - a JSON object to create an Element from
 * @returns a dimensional model instance
 * @internal
 */
function create(item) {
    if (Array.isArray(item)) {
        return createAll(item);
    }
    // todo: implement filter generation
    if (types_js_1.MetadataTypes.isFilter(item)) {
        return (0, filters_js_1.createFilter)(item);
    }
    else if (types_js_1.MetadataTypes.isMeasure(item)) {
        return (0, measures_js_1.createMeasure)(item);
    }
    else if (types_js_1.MetadataTypes.isAttribute(item)) {
        return (0, attributes_js_1.createAttribute)(item);
    }
    // dimension
    else if (types_js_1.MetadataTypes.isDimension(item) ||
        item.dim ||
        item.id ||
        item.type === 'dimension' ||
        item.attributes ||
        item.dimtype) {
        return (0, index_js_1.createDimension)(item);
    }
    throw new translatable_error_js_1.TranslatableError('errors.unsupportedDimensionalElement');
}
exports.create = create;
